import type { Routes } from '@angular/router';

import { RoutePath, StatisticsType } from '@malou-io/package-utils';

import { aggregatedStatisticsReadGuard } from '#core/guards/statistics-read.guard';
import { KeywordsStore } from '#modules/keywords/stores/keywords.store';
import { AGGREGATED_STATISTICS_PDF_ROUTES } from '#shell/routing/logged-in/groups/aggregated-statistics-pdf/aggregated-statistics-pdf.routing';
import { provideAggregatedStatisticsScope } from '#shell/routing/logged-in/groups/aggregated-statistics/aggregated-statistics.providers';

export const AGGREGATED_STATISTICS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/groups/aggregated-statistics-layout/aggregated-statistics-layout.component').then(
                (m) => m.AggregatedStatisticsLayoutComponent
            ),
        providers: [provideAggregatedStatisticsScope()],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'seo',
            },
            {
                path: 'roi',
                loadChildren: () =>
                    import('#modules/stats-roi/routes/aggregated-roi.routes').then((m) => m.AGGREGATED_ROI_STATISTICS_ROUTES),
                data: { statisticsType: StatisticsType.ROI },
                canActivate: [aggregatedStatisticsReadGuard],
            },
            {
                path: 'seo',
                loadChildren: () =>
                    import('#modules/statistics-seo/routes/aggregated-statistics-seo.routes').then(
                        (m) => m.AGGREGATED_SEO_STATISTICS_ROUTES
                    ),
                data: { statisticsType: StatisticsType.SEO },
                canActivate: [aggregatedStatisticsReadGuard],
            },
            {
                path: 'e-reputation',
                loadChildren: () =>
                    import('#modules/statistics-e-reputation/routes/aggregated-e-reputation-statistics.routes').then(
                        (m) => m.AGGREGATED_E_REPUTATION_STATISTICS_ROUTES
                    ),
                data: { statisticsType: StatisticsType.E_REPUTATION },
                canActivate: [aggregatedStatisticsReadGuard],
            },
            {
                path: 'social-networks',
                loadChildren: () =>
                    import('#modules/statistics-social-networks/routes/aggregated-social-networks.routes').then(
                        (m) => m.AGGREGATED_SOCIAL_NETWORKS_STATISTICS_ROUTES
                    ),
                data: { statisticsType: StatisticsType.SOCIAL },
                canActivate: [aggregatedStatisticsReadGuard],
            },
            {
                path: 'totems',
                redirectTo: 'boosters',
                data: { routePath: RoutePath.TOTEMS },
            },
            {
                path: 'boosters',
                loadChildren: () =>
                    import('#modules/statistics-boosters/routes/aggregated-boosters-statistics.routes').then(
                        (m) => m.AGGREGATED_BOOSTERS_STATISTICS_ROUTES
                    ),
                data: { statisticsType: StatisticsType.BOOSTERS },
                canActivate: [aggregatedStatisticsReadGuard],
            },
            {
                path: 'download-pdf',
                loadChildren: () => AGGREGATED_STATISTICS_PDF_ROUTES,
                providers: [KeywordsStore],
            },
        ],
    },
];
